import { render, staticRenderFns } from "./ReclameAquiComplaintScore.container.vue?vue&type=template&id=f8735a60&"
import script from "./ReclameAquiComplaintScore.container.vue?vue&type=script&lang=ts&"
export * from "./ReclameAquiComplaintScore.container.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports